import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OnNavigateService } from '@core/feature';
import { routes as hybrisRoutes } from './hybris-routes';
import { routes } from './routes';

const appRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('./lazy-reexports/page-layout').then((m) => m.PageLayoutComponent),
    children: [...routes, ...hybrisRoutes],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, {
      // за восстановление скролла отвечает OnNavigateService
      anchorScrolling: 'disabled',
      initialNavigation: 'enabledBlocking',
      scrollPositionRestoration: 'disabled',
    }),
  ],
  providers: [
    provideAppInitializer(() => {
      const initializerFn = ((onNavigateService: OnNavigateService): (() => void) => {
        return () => onNavigateService.initializeWithConfig();
      })(inject(OnNavigateService));

      return initializerFn();
    }),
  ],
})
export class AppRoutingModule {}
